import { Component, Inject, OnInit } from "@angular/core";
import { MatBottomSheet, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { AuthService } from "../../core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { map } from "rxjs/operators";
import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import { SyndicateSummary } from "@core/syndicate-summary.servics";
import { Data } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { InProgressAnimationComponent } from "../in-progress-animation/in-progress-animation.component";
import { AsyncPipe } from "@angular/common";

var MarkdownIt = require("markdown-it"),
  md = new MarkdownIt();

@Component({
    selector: "app-syndicate-summary",
    templateUrl: "./syndicate-summary.component.html",
    styleUrls: ["./syndicate-summary.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        InProgressAnimationComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class SyndicateSummaryComponent implements OnInit {
  selectedLanguage: string = "en";

  markUpContent$ = this.syndicateService.getSyndicateSummaryMarkup().pipe(
    map((data: Data) => {
      // Optional-chain through _detail so a null emission (Firestore listener
      // fallback) does not throw when indexing the language key.
      var rawData = data?._detail?.[this.selectedLanguage ?? 'en'];
      if (rawData) {
        rawData = rawData.replace(/@NL@/g, "\n");
      } else {
        rawData = "something went wrong";
      }
      return md.render(rawData);
    })
  );
  syndicateList: Data;
  syndicateSummaryData: Data;
  timeOut = 5000;
  constructor(
    private bottomSheet: MatBottomSheet,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data,
    private syndicateService: SyndicateDataService,
    public translate: TranslateService,
    private authService: AuthService,
    private syndicateSummary: SyndicateSummary,
    private GTMSegment: GTMSagmentService
  ) {
   // this.timeOut = 5000;
    try {
      this.authService?.selectedlanguage$?.subscribe(
        (l) => {
          this.selectedLanguage = l ? l : "en";
          translate.use(l ? l : "en");
        },
        (err) => {
          return err;
        }
      );
      this.GTMSegment.GTMPopupInitialization("SyndicateSummary");
    } catch (e) {
      return e;
    }
  }

  ngOnInit() {
    this.syndicateSummary.updateSyndicates()?.subscribe(res => {
      if (res?.status === "success") {
        const syndicate_name = this.data?.syndicateName;
        console.log('component = ', syndicate_name);
        this.syndicateSummary?.getSyndicateSummary(syndicate_name)?.subscribe((ref) => {
          this.syndicateSummaryData = ref;
          const claimRefDataAry = this.syndicateSummaryData?.claimref;
          let arr = [];
          if (Array.isArray(claimRefDataAry)) {
            claimRefDataAry.forEach((claimRefData) => {
              arr.push(claimRefData);
            });
          } else {
            arr.push(claimRefDataAry);
          }
          setTimeout(()=>{
            this.syndicateList = arr;
          }, this.timeOut)
          
        });
      } else {
        const errorCode = res?.error_code || "1097";
        this.syndicateList = [];
        this.authService
        .getConstantsMsg(errorCode)
        .then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "Something went wrong!",
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          this.authService.showToastMessage(translatedMsg, defaultMsg);
          this.bottomSheet.dismiss();
        })
        .catch((error) => {
          return error;
        });
      }
    });
  }

  dismissBottomSheet() {
    this.bottomSheet.dismiss();
  }
}
